export enum CompanyTypeConfiguration {
    Membership = 0,
    CRM = 1
}